var _tspan, _tspan2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSmallWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 176 145",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M145.707,0.686l0,97.32l-27.715,0l0,-75.254l-16.873,0l12.29,-22.077l32.298,0.011Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.544,0.675l-41.725,75.137l47.655,0l0,22.194l-86.792,0l41.421,-75.258l-38.461,0l0,-22.073l77.902,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("text", {
    x: "-0.486px",
    y: "143.943px",
    style: {
      fontFamily: "'Montserrat-Bold', 'Montserrat'",
      fontWeight: 700,
      fontSize: "30.231px",
      fill: "#fff"
    }
  }, "Str", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "44.71px ",
    y: "143.943px "
  }, "e")), "etZ", _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: "116.086px 135.887px 156.958px ",
    y: "143.943px 143.943px 143.943px "
  }, "one")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmallWhite);
export default __webpack_public_path__ + "static/media/logo-small-white.abdb9c1a.svg";
export { ForwardRef as ReactComponent };